import get from 'lodash/get';

const PATHS = {
    login: '/oauth/token',
    logout: '/oauth/revoke',
    refresh: '/oauth/token',
};

Object.freeze(PATHS);

const ERROR_TO_USER_MESSAGE = {
    401: 'Invalid session, please log back in.',
    invalid_grant: 'Your authorization request was not valid.',
};

class AuthService {
    /**
     * Should be implemented in a wrapper
     */
    static getAccessToken;
    static getRefreshToken;
    static refreshTokenCallback;

    constructor(restService) {
        this.restService = restService;
    }

    async login({ email, password }) {
        try {
            const { data } = await this.restService.post(PATHS.login, {
                username: email,
                password: password,
                client_id: process.env.REACT_APP_CLIENT_ID,
                grant_type: 'password',
                scope: 'data read',
            });

            return Promise.resolve(data);
        } catch (error) {
            return this.#handleErrors(error);
        }
    }

    async logout() {
        try {
            await this.restService.post(
                PATHS.logout,
                {
                    client_id: process.env.REACT_APP_CLIENT_ID,
                },
                {
                    token: AuthService.getAccessToken(),
                }
            );
        } catch (error) {
            return this.#handleErrors(error);
        }
    }

    async refreshToken() {
        try {
            const { data } = await this.restService.post(PATHS.refresh, {
                client_id: process.env.REACT_APP_CLIENT_ID,
                grant_type: 'refresh_token',
                refresh_token: AuthService.getRefreshToken(),
            });

            AuthService.refreshTokenCallback(data);
            return Promise.resolve(data.access_token);
        } catch (error) {
            return this.#handleErrors(error);
        }
    }

    #handleErrors(error) {
        let errorMessages = [];
        const friendlyMessage = ERROR_TO_USER_MESSAGE[get(error, 'response.data.error')];
        const serverErrorMessages = get(error, 'response.data.errors');

        if (friendlyMessage) {
            errorMessages.push(friendlyMessage);
        } else {
            errorMessages.concat(serverErrorMessages);
        }

        return Promise.reject(errorMessages);
    }
}

export default AuthService;
